import type { TTableSettingsModel } from 'src/services/user-settings-service/types';

export const MUI_KEY =
  '41e30292e843764d4d525ef823c50677Tz04MTE4NixFPTE3MzUyNjk2MzgwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y';

export const CHECK_COLUMN = '__check__';
export const ADD_ROWS_COLUMN = '__add-rows__';
export const ROW_GROUP_BY_COLUMN = '__row_group_by_columns_group__';
export const REORDER_COLUMN = 'reorder';
export const GROUPING_COLUMN = 'groupId';

export const DEFAULT_TABLE_SETTINGS_MODEL: Omit<TTableSettingsModel, 'ownerUserId'> = {
  filterModel: { items: [] },
  columnsOrderModel: [],
  columnsVisibility: {},
  sortingModel: [],
  columnsWidth: {},
  pinnedColumns: {},
};
